import React, { useState } from 'react'

import {
  Container,
  Content,
  TextHolder,
  BuyButton,
  IconHolder,
  CenteredTitle,
  CenteredP,
} from './style.css'
import OpticalIcon from '../../images/optical.svg'

const Planes = () => {
  const [loading, setLoading] = useState(true)
  const [loadingError, setLoadingError] = useState(true)

  return (
    <Container>
      <Content>
        <TextHolder>
          <CenteredTitle>
            <IconHolder className="optical" src={OpticalIcon} />{' '}
            {loading
              ? 'Forma parte de nuestra comunidad'
              : '¿Qué incluye tu plan?'}
          </CenteredTitle>
          <CenteredP>
            {' '}
            {loading
              ? 'Explora las distintas ofertas de suscripción y encuentra un plan que se ajuste a tus gustos e intereses.'
              : 'Descubre todos los beneficios de cada plan'}
          </CenteredP>

          <BuyButton
            href="https://suscripciondigital.latercera.com/?utm_source=btn_conoce_mas&utm_medium=web&utm_campaign=landing_especiales"
            target="_blank"
            rel="noopener noreferrer">
            {loading ? 'Conoce más' : 'Suscríbete'}
          </BuyButton>
        </TextHolder>
      </Content>
    </Container>
  )
}

export default Planes
